import { DatePipe, CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { FotaApiService } from '../CommonController/fota-api-service';
import { exportAsExcelFile } from '../shared/function/exportDataToExcel';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { DeviceApiService } from '../CommonController/device-api-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-details-page',
  templateUrl: './device-details-page.component.html',
  styleUrls: ['./device-details-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatIcon,
    MatTooltip,
    CommonPaginationComponent,
    CommonSearchComponent,
    DatePipe,
    NgxPaginationModule,
  ],
})
export class DeviceDetailsPageComponent implements OnInit {
  loginPacketArray = [];
  pageSize = 10;
  totalPages = 0;
  currentPage = 1;

  uid = '';
  imei = '';

  deviceDetails;
  deviceForm: FormGroup;
  deviceDataLogin = [];
  latestLoginTime = '';
  deviceCurrentState: any = {};

  ignition;
  mains;
  emergency;
  tamper;
  calib;
  wirecut;
  deviceLoginPackets = [];
  deviceLoginData = [];
  accel_data = [];
  selectedLoginPacket = [];
  otaViewPermission = false;
  FotaViewPermission = false;
  userPermission = [];

  projectName = environment.projectName;
  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public commonApiService: CommonApiService,
    public fotaApiService: FotaApiService,
    public deviceApiService: DeviceApiService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceDetailsForm();
    this.getLoginPacketList();
  }

  checkPermission() {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Ota' && element.view === true) {
        this.otaViewPermission = true;
      }
    });
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Fota' && element.view === true) {
        this.FotaViewPermission = true;
      }
    });
  }

  getDeviceDetails() {
    if (this.imei.length < 5) {
      return;
    }
    this.fotaApiService.getDeviceDetails(this.imei).subscribe({
      next: (res) => {
        if (res.status) {
          this.deviceDetails = res.data;
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  setDeviceDetailsForm() {
    this.deviceForm = this.formBuilder.group({
      search: new FormControl(''),
    });
    this.uid = sessionStorage.getItem('uid');
    this.imei = sessionStorage.getItem('imei');
    this.deviceForm.get('search').setValue(this.imei ? this.imei : '');
  }

  getLoginPacketList() {
    this.spinner.show();
    this.fotaApiService
      .getLoginPacketList(this.currentPage - 1, this.pageSize, this.imei)
      .subscribe({
        next: (res) => {
          if (res.status) {
            for (const item of res.data) {
              try {
                item.data = JSON.parse(item.data);
                if (typeof item.data === 'string') {
                  item.data = JSON.parse(item.data);
                }
                // item.data = JSON.parse(JSON.parse(item.data)); // Ensure valid JSON
                item.ignition = item.data['login and HP']?.[0]?.Ign ?? '--'; // Add ignition key safely
              } catch (error) {
                console.error('Error parsing item.data:', error);
              }
            }
            this.totalPages = res.totalItems;
            this.loginPacketArray = res.data;
            if (res.data.length > 0) {
              this.latestLoginTime = res.data[0].createdAt;
              this.setKpiData(res.data[0].data['login and HP'][0]);
              this.deviceDataLogin = res.data[0].data['login and HP'];

              this.deviceDataLogin[0].accel_data =
                this.deviceDataLogin[0]?.accel_data
                  // ?.split(',')
                  ?.split(/[\s,]+/)
                  .map((val) => val.trim());
              const accelDataArr = this.deviceDataLogin[0].accel_data;
              if (
                Array.isArray(accelDataArr) &&
                accelDataArr.length > 0 &&
                typeof accelDataArr[0] === 'string'
              ) {
                this.accel_data = accelDataArr;
              } else {
                this.accel_data = [];
              }
              console.log(accelDataArr);
            } else {
              this.setKpiData(null);
            }
            sessionStorage.setItem(
              'uid',
              res.data.length > 0 && res.data[0].uid
                ? res.data[0].uid.trim()
                : '--'
            );
            sessionStorage.setItem(
              'imei',
              res.data.length > 0 && res.data[0].imei
                ? res.data[0].imei.trim()
                : '--'
            );
            this.imei = sessionStorage.getItem('imei');
            this.uid = sessionStorage.getItem('uid');
            this.getDeviceCurrentState();
            this.getDeviceDetails();
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
          } else {
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
            this.loginPacketArray = [];
            this.deviceDataLogin = [];
            this.setKpiData(null);
            sessionStorage.setItem('uid', '--');
            this.uid = '--';
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
          this.loginPacketArray = [];
          this.deviceDataLogin = [];
          this.setKpiData(null);
          sessionStorage.setItem('uid', '--');
          this.uid = '--';
        },
      });
  }

  getDeviceCurrentState() {
    this.deviceApiService.getDeviceCurrentState(this.imei).subscribe({
      next: (res) => {
        if (res.status) {
          this.deviceCurrentState = res.data;
        } else {
          this.deviceCurrentState = {};
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.deviceCurrentState = {};
        this.commonApiService.openSnackbar(error.error.message);
      },
    });
  }

  setKpiData(data) {
    if (data) {
      this.ignition = data.Ign;
      this.mains = data.MVtg;
      this.emergency = data.Emer;
      this.tamper = data.Tampr;
      this.calib = data.CALFLG;
      this.wirecut = data.WCUT;
    } else {
      this.ignition = null;
      this.mains = null;
      this.emergency = null;
      this.tamper = null;
      this.calib = null;
      this.wirecut = null;
    }
  }

  viewLoginPacketDetails(data) {
    this.selectedLoginPacket = data;
    this.selectedLoginPacket = Object.entries(this.selectedLoginPacket[0]).map(
      ([key, value]) => ({ key, value })
    );
    // Chunk it into pairs
    const packetRows = [];
    for (let i = 0; i < this.selectedLoginPacket.length; i += 2) {
      packetRows.push([
        this.selectedLoginPacket[i],
        this.selectedLoginPacket[i + 1] || { key: '', value: '' },
      ]);
    }
    this.selectedLoginPacket = packetRows;
    document
      .getElementById('loginPacketDetails')
      .parentElement.classList.add('active');
  }

  downloadLoginPacketData() {
    if (confirm('Are you sure?')) {
      const imei = this.imei;
      this.spinner.show();
      this.fotaApiService.getLoginPacketList(0, 50, imei).subscribe((res) => {
        if (res.status) {
          this.spinner.hide();
          this.deviceLoginData = [];
          for (const item of res.data) {
            item.data = JSON.parse(item.data);
            if (typeof item.data === 'string') {
              item.data = JSON.parse(item.data);
            }
            this.deviceLoginPackets = item.data['login and HP'];
            this.deviceLoginPackets.forEach((element) => {
              this.deviceLoginData.push({
                Header: element['Header'],
                Time: element['Time'],
                IMEI: element['IMEI'],
                ICCID: element['ICCID'],
                'UIN Number': element['UIN'],
                ACCOLADE_FIRMWARE_VERSION: element['ACCFW'],
                VIN: element['VIN'],
                firmwareSource: element['FW_SRC'],
                primaryIp: element['CHTP'],
                primaryPort: element['Port1'],
                secondaryIp: element['CIP1'],
                secondaryPort: element['Port2'],

                CIP2: element['CIP2'],
                Port3: element['Port3'],
                CIP3: element['CIP3'],
                Port4: element['Port4'],
                CIP4: element['CIP4'],
                Port5: element['Port5'],

                latitude: element['Lat'],
                latitudeDir: element['LatDir'],
                longitude: element['Long'],
                longitudeDir: element['LongDir'],
                GPSTM: element['GPSTM'],
                GPS_D: element['GPS_D'],
                QUA: element['QUA'],
                Sat: element['Sat'],
                Speed: element['Speed'],

                mainInputVtg: element['MVtg'],
                intBatteryVtg: element['IBTV'],
                ignition: element['Ign'],
                tamper: element['Tampr'],
                emergency: element['Emer'],
                WCUT: element['WCUT'],
                calibValidFlag: element['CALFLG'],

                UPTIME: element['UPTIME'],
                accel_data: element['accel_data'],
                UHeap: element['UHeap'],
                THeap: element['THeap'],
                HIST_CNT: element['HIST_CNT'],
                'DI-D4': element['DI-D4'],

                'A-V1': element['A-V1'],
                'A-V2': element['A-V2'],
                BTRAW: element['BTRAW'],
                LastSyn: element['LastSyn'],
                NSTS: element['NSTS'],
                CSQ: element['CSQ'],

                CREG: element['CREG'],
                CGREG: element['CGREG'],
                SKT_STS: element['SKT_STS'],
                MQTT: element['MQTT'],

                OPRN: element['OPRN'],
                SWT_RC: element['SWT_RC'],
                RBT_CNT: element['RBT_CNT'],
                CANBUS_STS: element['CANBUS_STS'],

                Err_CNT: element['Err_CNT'],
                RSVD0: element['RSVD0'],
                RSVD1: element['RSVD1'],
                RSVD2: element['RSVD2'],

                RSVD3: element['RSVD3'],
                RSVD4: element['RSVD4'],
                RSVD5: element['RSVD5'],
                RSVD6: element['RSVD6'],
                RSVD7: element['RSVD7'],
                RSVD8: element['RSVD8'],
                RSVD9: element['RSVD9'],
                FTER: element['FTER'],
              });
            });
          }
          exportAsExcelFile(this.deviceLoginData, 'Login_Packets');
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Something went wrong');
        }
      });
    }
  }

  onPageChange(event) {
    this.currentPage = event;
    this.getLoginPacketList();
  }

  onSizeChange(pageSize): void {
    this.pageSize = pageSize; // Update the pageSize
    this.currentPage = 1;
    this.spinner.show();
    this.getLoginPacketList();
  }

  onSearch(event: string) {
    if (event.length !== 15 || isNaN(parseInt(event))) {
      this.commonApiService.openSnackbar('Invalid IMEI. Please try again.');
    } else {
      this.spinner.show();
      sessionStorage.setItem('imei', event);
      this.ngOnInit();
    }
  }

  closeModal() {
    document
      .getElementById('loginPacketDetails')
      .parentElement.classList.remove('active');
  }

  redirectToFOTA(): void {
    sessionStorage.setItem('manualfotaimei', this.imei);
    this.router.navigate(['/manual-fota']);
  }

  redirectToOTA(): void {
    sessionStorage.setItem('manualotaimei', this.imei);
    this.router.navigate(['/manual-ota']);
  }

  getLocation(lat, long) {
    const url = `https://www.google.com/maps?q=${lat},${long}`;
    window.open(url, '_blank');
  }

  generateGoogleMapsLink() {
    const baseUrl = 'https://www.google.com/maps/dir/';
    const validCoordinates = this.loginPacketArray
      .filter((element) => {
        const item = element.data['login and HP'][0];
        const lat = parseFloat(item.Lat);
        const long = parseFloat(item.Long);

        return lat !== 0 && long !== 0 && !isNaN(lat) && !isNaN(long);
      })
      .map((element) => {
        const item = element.data['login and HP'][0];
        return [item.Lat, item.Long];
      });
    const limitedCoordinates = validCoordinates.slice(0, 25);
    if (limitedCoordinates.length < 2) {
      this.commonApiService.openSnackbar(
        'At least two valid coordinates are required.'
      );
      return;
    }
    const points = limitedCoordinates.map((coord) => coord.join(',')).join('/');
    return `${baseUrl}${points}`;
  }

  trackLocation() {
    this.commonApiService.openSnackbar('Tracking upto last 25 locations');
    const url = this.generateGoogleMapsLink();
    if (url) {
      window.open(url, '_blank');
    }
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
